export const RECAPTCHA_SITE_KEY = window.Cypress ? Cypress.env('VUE_APP_RECAPTCHA_SITE_KEY') : process.env.VUE_APP_RECAPTCHA_SITE_KEY

export const GA_ID = window.Cypress ? Cypress.env('VUE_APP_GA_ID') : process.env.VUE_APP_GA_ID
export const GA4_ID = window.Cypress ? Cypress.env('VUE_APP_GA4_ID') : process.env.VUE_APP_GA4_ID
export const GA4_PREFIX = 'G-'

export const UA_TO_GA4_ACTION_MAPPING = {
  'form-input': 'contact_us_form_input',
  'form-input-error': 'contact_us_form_input_error',
  'submit-with-errors': 'contact_us_submit_with_errors',
  'submit': 'contact_us_submit',
  'click': 'contact_us_submit_success',
  'submit-api-error': 'contact_us_submit_api_error'
}
